import { Component, OnInit, Input} from '@angular/core';

@Component({
  selector: 'app-products-availables',
  templateUrl: './products-availables.component.html',
  styleUrls: ['./products-availables.component.scss']
})
export class ProductsAvailablesComponent implements OnInit {
  @Input() productsList: any[]=[];
  constructor() { }

  ngOnInit() {
  }

  changeStateProduct(product:any){
    this.productsList.forEach((element)=>element.selected = false);
    product.selected = true;
  }

}
